import * as Yup from 'yup';
import { showWarningToast } from '../../../utils/toastHelper';
import i18next from 'i18next';
export const t = (key) => i18next.t(key, { ns: 'Products' });

export const productSchema = Yup.object().shape({
  code: Yup.string().required('PRODUCT_CODE_REQUIRED'),
  category: Yup.object().required('CATEGORY_REQUIRED'),
  process_category: Yup.object().required('PROCESS_CATEGORY_REQUIRED'),
  name: Yup.string()
    .trim()
    .required('PRODUCT_NAME_REQUIRED')
    .min(1, 'PRODUCT_NAME_MIN'),
  origin: Yup.object().required('ORIGIN_REQUIRED'),
  net_weight: Yup.string().matches(
    /^\d+(\.\d+)?\s?[a-zA-Z]+$/,
    'NET_WEIGHT_FORMAT_INVALID'
  ),
  specification_value: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .min(0, 'SPECIFICATION_VALUE_MIN'),
  product_value: Yup.string().min(0, 'PRODUCT_VALUE_MIN'),
  product_unit: Yup.object().required('PRODUCT_UNIT_REQUIRED'),
  process_location: Yup.object().required('PROCESS_LOCATION_REQUIRED'),
});

export const validateProduct = async (data) => {
  try {
    await productSchema.validate(data, { abortEarly: false });
    return true;
  } catch (error) {
    //error.inner.forEach((err) => {
    //     showWarningToast(err.message);
    //    });
    if (Array.isArray(error.inner) && error.inner.length > 0) {
      const firstError = error.inner[0];
      if (firstError.message) {
        showWarningToast(t(firstError.message)); // Show the first message
      }
    }

    return false;
  }
};
